import { useTimeMarker } from '../../../hooks';
import { useTimelineStore } from '../../../store';

type TimeMarkerProps = {
  startDate: Date;
  endDate: Date;
};

export const TimeMarkerLine = ({ startDate, endDate }: TimeMarkerProps) => {
  const currentFilter = useTimelineStore((state) => state.filters.current);
  const { isTimeMarkerVisible, timeMarkerDistance } = useTimeMarker(startDate, endDate, currentFilter.measureScale);

  if (!isTimeMarkerVisible) {
    return null;
  }

  return (
    <div className="absolute top-0 bottom-0 z-22 w-[3px] bg-surface-brand/30" style={{ left: timeMarkerDistance }} />
  );
};
